export default "__VITE_ASSET__BowI$t8M__"